import React from 'react';
import { hourRangeFr } from './format';

/**
 * `.panel-horaires` — tableau des 7 jours, le jour courant mis en évidence.
 *
 * Le balisage `.ph-row { display: contents }` de la maquette est conservé
 * verbatim. Les horaires structurés ne sont pas repris ici en microdonnées :
 * ils sont déjà émis par le SSR (`Schema.json` hydraté par
 * `services/react_helper.js:243-260`), et les doubler brouillerait le JSON-LD.
 *
 * Un jour à plusieurs créneaux empile ses plages (`.ph-time` en flex colonne) :
 * la colonne du panneau latéral est trop étroite pour « 9h30–12h · 14h–19h30 »
 * sur une ligne, et un repli de ligne désalignerait le libellé du jour.
 *
 * Les jours dérogatoires (`additionalDays`) prennent la place de la ligne du
 * jour concerné, sans marqueur visuel — la maquette n'en prévoit aucun. Le motif
 * de la dérogation part dans le libellé accessible et en `title`.
 */
const OpeningHoursGrid = ({ schedule = [] }) => {
  if (!schedule.length) return null;

  return (
    <div className="panel-horaires">
      <div className="panel-horaires-box">
        <div className="panel-horaires-grid">
          {schedule.map((day) => (
            <div className={['ph-row', day.isToday ? 'today' : null].filter(Boolean).join(' ')} key={day.key}>
              <span className="ph-day">
                <span className="sr-only">
                  {day.fullName}
                  {day.isException ? ` — horaires exceptionnels${day.exceptionDesc ? ` : ${day.exceptionDesc}` : ''}` : ''}
                </span>
                <span aria-hidden="true">{day.shortName}</span>
              </span>
              <span className="ph-time" title={day.exceptionDesc || undefined}>
                {day.slots.length
                  ? day.slots.map((slot) => (
                      <span key={`${slot.begin}-${slot.end}`}>{hourRangeFr(slot.begin, slot.end)}</span>
                    ))
                  : 'Fermé'}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OpeningHoursGrid;
